module.exports = __webpack_public_path__ + "img/dy_icon.24d2067c.png";